import * as React from "react";
import Modal from "../Modal/Modal";
import "./Channel.css";

interface IChannelProps {
    name: string;
    src: string;
    shortDescription: string;
    longDescription: string;
    points?: number
}

class Channel extends React.Component<IChannelProps, {showModal: boolean}> {
    constructor(props: IChannelProps) {
        super(props);
        this.state = {
            showModal: false
        };
    }

    public toggleModal = () => {
        const modalBg = document.getElementById("modalBg")
        modalBg!.style.display = this.state.showModal
            ? "none"
            : "block";

        this.setState({showModal: !this.state.showModal});
    };

    public render() {
        return (
            <div>
                <div>
                    <div className="product" onClick={this.toggleModal}>
                        <i className="moreInfo icon-info-hvit-rgb" />
                        <img src={this.props.src} alt="" className={this.props.points ? "optional" : ""} />
                        <span className="channel-name">{this.props.name}</span>
                        {this.props.points ?
                            <div className="channel-points">
                                {this.props.points} poeng
                            </div> : null
                        }
                    </div>
                </div>

                {this.state.showModal
                    ? <Modal
                        name={this.props.name}
                        src={this.props.src}
                        longDescription={this.props.longDescription}
                        shortDescription={this.props.shortDescription}
                        toggleModal={this.toggleModal}/>
                    : ""}
            </div>
        );
    }
}

export default Channel;